import { Link } from "react-router-dom";
import { Compass } from "lucide-react";

export default function NotFound() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 text-center">
      <Compass className="mb-4 h-16 w-16 text-brandorange" />
      <h1 className="font-display text-6xl font-extrabold text-navy">404</h1>
      <p className="mt-2 text-lg text-gray-500">Looks like you've wandered off the map.</p>
      <Link to="/" className="btn-gradient mt-6 rounded-full px-7 py-3.5 font-bold">Back to Home</Link>
    </div>
  );
}
